import CachedIcon from '@mui/icons-material/Cached'
import DownloadDoneIcon from '@mui/icons-material/DownloadDone'
import {Button, Chip} from '@mui/material'
import Box from '@mui/material/Box'
import dayjs from 'dayjs'
import {envImagePath} from 'GLOBAL/envVariables'
import {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {getInstallList, imageDownload, imageRefresh} from 'utils/apiCalling/api'
import {getInstallDecisionColor} from 'utils/func/justUtils'

const NormalAs = (props: any) => {
  const {asSubmit, set, getPosition} = props
  const userInfo = useSelector((state: any) => state?.userInfo?.userInfo)
  const [refreshLoading, setRefreshLoading] = useState<boolean>(false)

  const refreshDeviceSignal = (imei: any) => {
    getInstallList(userInfo, 'as', null, {
      success: (res: any) => {
        const currentDevice = res?.find((d: any) => d.imei === imei)
        if (currentDevice) {
          set((prev: any) => ({
            ...prev,
            rssiStatus: currentDevice.rssiStatus ?? prev?.rssiStatus,
            temperature: currentDevice.temperature ?? prev?.temperature,
            linkquality: currentDevice.linkquality ?? prev?.linkquality,
          }))
        }
      },
      fail: (err: any) => console.log(err),
      loading: () => {},
    })
  }

  const imageRefreshCall = (silent = false) => {
    imageRefresh(
      asSubmit,
      {
        success: (res: any) => {
          getPosition()
          /* 새로고침은 '최신 사진 재요청'이라 응답이 비어 있으면 새 사진이 없다는 뜻이다.
             기존 이미지 정보를 지우면 화면과 다운로드가 함께 깨지므로 이전 값을 유지한다. */
          set((prev: any) => ({
            ...prev,
            imei: res?.imei ?? prev?.imei,
            idxDate: res?.idxDate ?? prev?.idxDate,
            filePath: res?.filePath ?? prev?.filePath,
            createAt: res?.createAt ?? prev?.createAt,
            rssiStatus: res?.rssiStatus ?? prev?.rssiStatus,
            temperature: res?.temperature ?? prev?.temperature,
            linkquality: res?.linkquality ?? prev?.linkquality,
          }))
        },
        fail: (err: any) => console.log(err),
        loading: (loading: boolean) => {
          setRefreshLoading(loading)
          if (!loading) refreshDeviceSignal(asSubmit?.imei)
        },
      },
      {silent}
    )
  }

  /* 접수 당시 사진(beforeImageIdxDate)이 없는 A/S 는 idxDate 가 비어 완료 요청에 null 로 나간다.
     9/10 이후 이번 배포 전까지 접수된 건이 그렇다. 들어오자마자 한 번 새로고침해 최신 사진으로 채운다.
     (StrictMode 에서 effect 가 두 번 돌아도 요청은 한 번만 나가도록 ref 로 막는다) */
  const autoRefreshed = useRef(false)
  useEffect(() => {
    if (autoRefreshed.current) return
    autoRefreshed.current = true
    if (!asSubmit?.idxDate && asSubmit?.imei) imageRefreshCall(true)
  }, [])

  return (
    <Box className={'my-2 p-2 border border-gray-400 rounded-2'}>
      {refreshLoading ? (
        <div className={'d-flex justify-content-center align-items-center my-5'}>
          <div className='spinner-border text-primary' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      ) : (
        <div className={'text-center'}>
          <div className={'w-100 d-grid justify-content-center'}>
            <img src={`${envImagePath}${asSubmit?.filePath}`} alt={'device'} style={{width: 320}} />
          </div>
          <div className={'mt-2'}>
            <div className={'d-flex align-items-baseline justify-content-between mb-1'}>
              <span className={'fs-4 fw-bold'}>마지막 통신 시각</span>
              <span className={'fs-3 fw-bold'}>
                {dayjs(asSubmit?.createAt).format('YY.MM.DD HH시 mm분 ss초')}
              </span>
            </div>
            <div className={'d-flex flex-wrap align-items-center gap-2'}>
              <span style={{backgroundColor: getInstallDecisionColor(asSubmit?.rssiStatus != null ? Number(asSubmit.rssiStatus) : null, asSubmit?.linkquality != null ? Number(asSubmit.linkquality) : null), color: 'white', padding: '6px 16px', borderRadius: '20px', fontWeight: 'bold', fontSize: '1.4rem', display: 'inline-flex', alignItems: 'center', gap: '10px'}}>
                전파 세기 : {asSubmit?.rssiStatus}dBm
                <span style={{opacity: 0.5}}>|</span>
                전파 품질 : {asSubmit?.linkquality ?? '-'}dB
              </span>
              {Number(asSubmit?.temperature || 99) < 90 && (
                <Chip
                  label={`온도 : ${asSubmit?.temperature}°C`}
                  color={'success'}
                  variant={'filled'}
                  sx={{fontSize: '1.3rem', height: 32}}
                />
              )}
            </div>
          </div>
          <div className={'my-2 d-flex gap-2'}>
            <Button
              variant={'contained'}
              color={'warning'}
              fullWidth
              startIcon={<CachedIcon />}
              onClick={() => imageRefreshCall()}
            >
              새로고침
            </Button>
            <Button
              variant={'contained'}
              color={'success'}
              fullWidth
              startIcon={<DownloadDoneIcon />}
              disabled={!asSubmit?.filePath}
              onClick={async () =>
                await imageDownload(asSubmit?.filePath, 32, 255, 0, asSubmit?.beforeImei)
              }
            >
              다운로드
            </Button>
          </div>
        </div>
      )}

    </Box>
  )
}

export default NormalAs
